export default __webpack_public_path__ + "static/media/toxplot-logo.cd83ccf2.png";